var t = function(r, o) {
  return typeof r == "string" ? r : typeof r == "number" && r > -1 && r < 1 ? "".concat(100 * r, "%") : typeof r == "number" && (r >= 1 || r <= -1) ? "".concat(r * o, "px") : r;
};
export {
  t as getAutoOrScaleIndent
};
